export default "__VITE_ASSET__0136c1c1__"